import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import CustomerService from 'Component/CustomerService/CustomerService.container';
import NewIssuePopup from 'Component/NewIssuePopup';

import './MyAccountCustomerServicePush.style';

/** @namespace PeggysagePwa/Component/MyAccountCustomerServicePush/Component */
export class MyAccountCustomerServicePushComponent extends PureComponent {
    static propTypes = {
        onTicketButtonClick: PropTypes.func.isRequired
    };

    renderTicketButton() {
        const { onTicketButtonClick } = this.props;

        return (
            <button
              type="button"
              block="MyAccount"
              elem="TicketButton"
              mix={ { block: 'Button', mods: { likeLink: true } } }
              onClick={ onTicketButtonClick }
            >
                { __('Faire une demande') }
            </button>
        );
    }

    render() {
        return (
            <div block="MyAccount" elem="CustomerServicePush">
                <h3 block="MyAccount" elem="CustomerServicePushTitle">
                    { __('Une réclamation ou question sur votre commande ?') }
                </h3>
                <CustomerService
                  hasContactLink={ false }
                  title=""
                />
                { this.renderTicketButton() }
                <NewIssuePopup />
            </div>
        );
    }
}

export default MyAccountCustomerServicePushComponent;
